import styles from "./MobileCarouselDots.module.css";

export default function MobileCarouselDots({ count, activeIndex, onSelect, className = "" }) {
  if (!count || count <= 1) return null;

  return (
    <div
      className={`${styles.dots} ${className}`.trim()}
      aria-label="Slides"
    >
      {Array.from({ length: count }).map((_, index) => (
        <button
          key={index}
          type="button"
          className={`${styles.dot} ${activeIndex === index ? styles.dotActive : ""}`}
          aria-label={`Go to slide ${index + 1}`}
          aria-current={activeIndex === index ? "true" : undefined}
          onClick={() => onSelect(index)}
        />
      ))}
    </div>
  );
}
